import React from 'react'
import Breadcrumb from '../../../../Components/Utils/Breadcrumb'
import { BackButton } from '../../../../Components/Utils/Buttons'

function DropdownIndex() {
    return (
        <div className="w-full h-full px-4 py-2">
          <div className="w-full flex justify-between items-center">
            <Breadcrumb
              items={[
                {
                  name: "Settings",
                },
                {
                  name: "DropDown",
                },
              ]}
            />
            <BackButton />
          </div>
          <div className="w-full h-[calc(100vh-145px)] bg-white mt-3 mx-auto  p-2 rounded-md overflow-y-scroll">
            <div className=" w-full flex justify-between items-center">
    {/* <EmailServer/> */}
              </div>
              </div>
              </div>
       )
}

export default DropdownIndex
